'use client';

import React, { useState } from 'react';
import { TextInput, Button, Paper, Title, Stack } from '@mantine/core';
import { useAuth } from '../hooks/useAuth';
import { createOrganization } from '../services/firestore';
import { CreateOrganizationProps } from '../types';

export const CreateOrganization: React.FC<CreateOrganizationProps> = ({ 
  onSuccess, 
  onError 
}) => {
  const { user } = useAuth();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!user || !name.trim()) return;
    
    setLoading(true);
    
    try {
      const orgId = await createOrganization({
        name: name.trim(),
        ownerId: user.uid,
        members: [{
          userId: user.uid,
          role: 'owner' as const,
          joinedAt: new Date()
        }]
      });
      onSuccess?.(orgId);
      setName('');
    } catch (error) {
      console.error('Error creating organization:', error);
      onError?.(error as Error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper radius="md" p="xl" withBorder>
      <Title order={2} mb="md">Create Organization</Title>
      
      <form onSubmit={handleSubmit}>
        <Stack>
          <TextInput
            required
            label="Organization Name"
            placeholder="Enter organization name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          
          <Button 
            type="submit" 
            loading={loading}
            disabled={!name.trim()}
          >
            Create
          </Button>
        </Stack>
      </form>
    </Paper>
  );
}; 